import React, { useEffect } from 'react';
import OrderDetailView from './OrderDetailView';
import WithLoading from '../../../Hoc/WithLoading';

export const getOrderApi = `/order/:id`;

const OrderDetail = ({ id }) => {
  useEffect(() => {}, [id]);
  return (
    <WithLoading
      component={OrderDetailView}
      url={getOrderApi.replace(':id', id)}
    />
  );
};

export default React.memo(OrderDetail);
